import React from 'react';

export const IndexPage = () => {
    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <h4>Dit ziet er helemaal anders uit, wat is dat nu?</h4>
            <p>Dit is de nieuwe databank voor D.O.P. die nog in ontwikkeling is.</p>
            
            <hr />

            <h4>Veel gestelde vragen</h4>
            <ul>
                <li>
                    <strong>Maar waarom?</strong><br />
                    De database zoals we die kennen is verouderd en een likje verf hier en een baksteentje daar was nodig. Alles omzetten naar deze website
                    zorgt ervoor dat we de database kunnen uitbreiden met nieuwe functionaliteiten, future-proof maken en geschikt maken voor alle browsers en toestellen.
                </li>
                <li>
                    <strong>Maar waar vind ik de rapporten die ik eigenlijk aan het zoeken was?</strong><br />
                    In het menu links vind je de knop "Rapporten". Hier kan je de rapporten vinden die je zoekt. Alle oude vertrouwde rapporten zijn hier nog steeds beschikbaar.
                </li>
                <li>
                    <strong>En wat met outreach?</strong><br />
                    Outreach is het eerste onderdeel dat we hebben omgezet naar de nieuwe databank. Je kan hier al je outreach activiteiten registreren en bekijken.
                </li>
                <li>
                    <strong>En de rest?</strong><br />
                    De rest van de databank is nog in ontwikkeling. We zijn bezig met het omzetten van de andere onderdelen en zullen deze zo snel mogelijk beschikbaar maken.
                </li>
                <li>
                    <strong>Wat is die knop "Oude Database"?</strong><br />
                    Klik er eens op en kijk wat er gebeurt.
                </li>
            </ul>
        </div>
    );
};

export default IndexPage;